import React from 'react';
import { Button } from '../ui/button';
import { Bot, Sparkles } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const AIAssistantButton = ({ onClick, isOpen }) => {
  const { user } = useAuth();
  
  // Only show for instructors and admins
  const hasAccess = ['Instructor', 'TenantAdmin', 'SuperAdmin'].includes(user?.role);
  
  if (!hasAccess) return null;

  return (
    <Button
      onClick={onClick}
      className={`fixed bottom-6 right-6 w-14 h-14 rounded-full shadow-lg z-[60] transition-all ${
        isOpen 
          ? 'bg-gray-600 hover:bg-gray-700' 
          : 'bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700'
      }`}
      size="icon"
      title="AI Teaching Assistant"
    >
      {isOpen ? (
        <span className="text-white text-xl">×</span>
      ) : (
        <div className="relative">
          <Bot className="w-6 h-6 text-white" />
          <Sparkles className="w-3 h-3 text-yellow-300 absolute -top-1 -right-1" />
        </div>
      )}
    </Button>
  );
};

export default AIAssistantButton;
